import { useState, useRef, useEffect, useMemo } from "react";
import { classNames } from "primereact/utils";
import { useHistory, useLocation, Redirect } from "react-router-dom";
import LegacyDashboardSidebar from "./components/LegacyDashboardSidebar/LegacyDashboardSidebar";
import { Tooltip } from "primereact/tooltip";
import GetUserInfoService from "../../service/GetUserInfoService";
import "./components/UserDashboardHome/UserDashboardHome.css";
import "./components/DashboardLayout.css";
import UserDashboardHome from "./components/UserDashboardHome/UserDashboardHome";
import ManagerDashboardHome from "./pages/ManagerDashboard/ManagerDashboardHome";
import NetworkTable from "./components/NetworkTable/NetworkTable";
import EditProfileInfo from "./components/EditProfileInfo/EditProfileInfo";
import localeText from "../../locale";
import StatementTable from "./components/StatementTable/StatementTable";
import { Dialog } from "primereact/dialog";
import Coupons from "./components/Coupons/Coupons";
import ProductsList from "./components/ProductsList/ProductsList";
import NewProduct from "./components/NewProduct/NewProduct";
import Attributes from "./components/Attributes/Attributes";
import Orders from "./components/Orders/Orders";
import ExtracoinTransfer from "./components/ExtracoinTransfer/ExtracoinTransfer";
import ExtracoinIntents from "./components/ExtracoinIntents/ExtracoinIntents";
import WithdrawIntent from "./components/WithdrawIntent/WithdrawIntent";
import ConfirmDocument from "../../components/ConfirmDocument/ConfirmDocument";
import FiscalDataGate from "../../components/FiscalDataGate/FiscalDataGate";
import AdminEntry from "../AdminPanel/AdminEntry";
import handleCurrency from "../../utilities/CurrencySwitch";
import UserStore from "./components/UserStore/UserStore";
import FavoritedProducts from "./components/FavoritedProducts/FavoritedProducts";
import ExtraPay from "./components/ExtraPay/ExtraPay";
import ImportProducts from "./components/ImportProducts/ImportProducts";
import Web3Dashboard from "./components/web3Dashboard/web3Dashboard";
import { formatDate } from "../../utilities/formatDate";
import { useToggle } from "../../hooks/useToggle";
import { Button } from "primereact/button";
import RenewSubscription from "./components/RenewSubscription/RenewSubscription";
import OrderDetails from "./components/OrderDetails/OrderDetails";
import StoresMap from "./components/storesMap/index";
import DashboardRouter from "./routing/DashboardRouter";
import useDashboardPermissions from "./hooks/useDashboardPermissions";
import EvaluateOrder from "./components/Orders/EvaluateOrder/EvaluateOrder";
import StoreTransactions from "./components/StoreTransactions/StoreTransactions";
import QrCodePay from "./components/QrCodePay/QrCodePay";
import FringeBenefit from "./components/FringeBenefit/FringeBenefit";
import FringeBenefitsList from "./components/FringeBenefitsList/FringeBenefitsList";
import FringeBenefitEdit from "./components/FringeBenefitEdit/FringeBenefitEdit";
import FringeBenefitsPurchases from "./components/FringeBenefitsPurchases/FringeBenefitsPurchases";
import FringeBenefitsSales from "./components/FringeBenefitsSales/FringeBenefitsSales";
import FinancialHub from "./pages/FinancialHub/FinancialHub";
import ExtrapayPage from "./pages/FinancialHub/Extrapay/ExtrapayPage";
import ExtrapayKnowPage from "./pages/FinancialHub/Extrapay/ExtrapayKnowPage";
import ExtrapayWithdrawPage from "./pages/FinancialHub/Extrapay/ExtrapayWithdrawPage";
import ExtrapayWithdrawDetailsPage from "./pages/FinancialHub/Extrapay/ExtrapayWithdrawDetailsPage";
import ExtrapayCyclePage from "./pages/FinancialHub/Extrapay/ExtrapayCyclePage";
import WalletPage from "./pages/FinancialHub/WalletPage";
import EconomicCirclePage from "./pages/EconomicCircle/EconomicCirclePage";
import EconomicCircleInvitePage from "./pages/EconomicCircle/EconomicCircleInvitePage";
import EconomicCircleMembersPage from "./pages/EconomicCircle/EconomicCircleMembersPage";
import ExtracreditPage from "./pages/FinancialHub/ExtracreditPage";
import ExtracreditTransferPage from "./pages/FinancialHub/ExtracreditTransferPage/ExtracreditTransferPage";
import { ThemeProvider } from "../../contexts/ThemeContext/ThemeContext";
import WhiteLabelPage from "./pages/WhiteLabel/WhiteLabelPage";
import PartnerB2BPage from "./pages/PartnerB2B/PartnerB2BPage";
import PartnerServicesPage from "./pages/PartnerServices/PartnerServicesPage";
import MyCards from "./pages/MyCards/MyCards";
import BusinessDiagnosisPage from "./pages/BusinessDiagnosis/BusinessDiagnosisPage";
import ManagerLayout from "./components/ManagerLayout/ManagerLayout";
import StorePanelPage from "./pages/Store/StorePanelPage";
import StoreOrdersPage from "./pages/Store/StoreOrdersPage";
import StoreSettingsPage from "./pages/Store/StoreSettingsPage";
import StoreOrderDetailsPage from "./pages/Store/StoreOrderDetailsPage";
import StoreProductsPage from "./pages/Store/StoreProductsPage";
import StoreProductFormPage from "./pages/Store/StoreProductFormPage";
import StoreSchedulesPage from "./pages/Store/StoreSchedulesPage";
import PhysicalStorePage from "./pages/Store/PhysicalStorePage";
import CustomerDashboardHome from "./pages/CustomerDashboard/CustomerDashboardHome";
import CustomerIntegrationsPage from "./pages/CustomerIntegrations/CustomerIntegrationsPage";
import UpgradePage from "./pages/Upgrade/UpgradePage";
import "./styles/theme-variables.css";
import UnderConstruction from "../UnderConstruction/UnderConstruction";
import SEO from "../../components/SEO/SEO";

const isStoreStartSellerEnabled = (userTypeInfo, userInfo) => {
  if (userTypeInfo !== "Store") return false;
  return userInfo?.showCase === true || userInfo?.showCase === "true" || userInfo?.showcase === true || userInfo?.showcase === "true";
};

const UserDashboard = () => {
  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [userPlan, setUserPlan] = useState();
  const copyTooltipRef = useRef();
  const maskTouchStartRef = useRef(null);

  // API INFO
  const [userInfo, setUserInfo] = useState(null);
  const [userTypeInfo, setUserTypeInfo] = useState(null);
  const [walletInfo, setWalletInfo] = useState(null);
  const [extracoinInfo, setExtracoinInfo] = useState(null);
  const [currency, setCurrency] = useState("$");
  const [directsInfo, setDirectsInfo] = useState(null);
  const [allNodesInfo, setAllNodesInfo] = useState(null);
  const [directsArray, setDirectsArray] = useState([]);
  const [allNodesArray, setAllNodesArray] = useState([]);

  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const [isLoadingSubscriptionInfo, setIsLoadingSubscriptionInfo] = useState(true);

  const [activationInfo, setActivationInfo] = useState(null);
  const [lifetimeBonusInfo, setLifetimeBonusInfo] = useState(null);
  const [extracoinPercentage, setExtracoinPercentage] = useState(null);
  const [loadingAdmin, setLoadingAdmin] = useState(true);
  const [userAdminType, setUserAdminType] = useState(null);
  const [productsRefreshTrigger] = useState(0);
  const canAccessUpgradePage =
    ["Customer", "Partner", "Seller"].includes(userTypeInfo) ||
    (userTypeInfo === "Store" && !isStoreStartSellerEnabled(userTypeInfo, userInfo));

  const Navigate = useHistory();
  const location = useLocation();

  const userHasSubscription =
    userTypeInfo &&
    (/manager/i.test(userTypeInfo) ||
      /partner/i.test(userTypeInfo) ||
      /seller/i.test(userTypeInfo));

  const { canViewFeature } = useDashboardPermissions(userTypeInfo, userInfo);

  function getProductServicesItems() {
    let items = [
      {
        label: localeText("new"),
        icon: "pi pi-fw pi-plus",
        to: "userstore",
        id: "step-7",
      },
      { label: localeText("list"), icon: "pi pi-fw pi-list", to: "products" },
      { label: localeText("attributes"), icon: "pi pi-fw pi-tags", to: "attributes" },
      { label: localeText("favorites"), icon: "pi pi-fw pi-heart-fill", to: "favorites" },
      {
        label: localeText("importProducts"),
        icon: "pi pi-fw pi-file-import",
        to: "importproducts",
      },
      {
        label: localeText("yourStore"),
        icon: "pi pi-fw pi-shopping-bag",
        to: "newproduct",
        id: "step-6",
      },
    ];

    if (["Seller", "Manager"].includes(userPlan)) {
      items = items.concat([
        {
          label: localeText("dropshipping"),
          icon: "pi pi-fw pi-shopping-cart",
          to: "dropshipping",
        },
      ]);
    }
    return items;
  }

  const getSimplifiedMenu = () => {
    // Para Promoter, remover funcionalidades de e-commerce
    if (userTypeInfo === "Promoter") {
      return [
        {
          label: localeText("dashboard"),
          icon: "pi pi-table",
          items: [{ label: localeText("userDashboard"), icon: "pi pi-table", to: "/dashboard" }],
        },
        {
          label: localeText("financial"),
          icon: "pi pi-wallet",
          getIsActive: (match, location) => location.pathname.startsWith("/dashboard-financeiro"),
          items: [
            {
              label: localeText("centralFinanceira"),
              icon: "pi pi-wallet",
              to: "/dashboard-financeiro",
            },
            {
              label: localeText("wallet"),
              icon: "pi pi-wallet",
              to: "/dashboard-financeiro/carteira",
            },
            {
              label: "Extracredit",
              icon: "pi pi-dollar",
              to: "/dashboard-financeiro/extracredit",
            },
            {
              label: localeText("extrapayFlowTitle"),
              icon: "pi pi-bolt",
              to: "/dashboard-financeiro/extrapay",
            },
            {
              label: "Bonus ads",
              icon: "pi pi-money-bill",
              to: "/dashboard-extrabonusStatement",
            },
            {
              label: localeText("bonus"),
              icon: "pi pi-star",
              to: "/dashboard-bonusStatement",
            },
          ],
        },
        {
          label: localeText("myPurchases") || "Minhas compras",
          icon: "pi pi-shopping-cart",
          to: "/dashboard-purchases",
          getIsActive: (match, location) => location.pathname.startsWith("/dashboard-purchases"),
        },
        {
          label: localeText("economicCircle"),
          icon: "pi pi-sitemap",
          to: "/dashboard-economic-circle",
          items: [
            {
              label: localeText("invite"),
              icon: "pi pi-link",
              to: "/dashboard-economic-circle/invite",
            },
            {
              label: localeText("membersAndTransactions"),
              icon: "pi pi-users",
              to: "/dashboard-economic-circle/members",
            },
          ],
        },
        {
          label: localeText("map"),
          icon: "pi pi-map-marker",
          to: "/dashboard-mapstores",
          getIsActive: (match, location) => location.pathname.startsWith("/dashboard-mapstores"),
          items: [
            { label: localeText("map"), icon: "pi pi-map-marker", to: "/dashboard-mapstores" },
          ],
        },
      ];
    }
    // ...restante igual para outros perfis
    const menuItems = [
      {
        label: localeText("dashboard"),
        icon: "pi pi-table",
        items: [{ label: localeText("userDashboard"), icon: "pi pi-table", to: "/dashboard" }],
      },
      canAccessUpgradePage && ["Seller", "Partner", "Store"].includes(userTypeInfo) && {
        label: localeText("upgradeAccount"),
        icon: "pi pi-chart-line",
        to: "/dashboard-upgrade",
        getIsActive: (match, location) => location.pathname.startsWith("/dashboard-upgrade"),
      },
      {
        label: localeText("financial"),
        icon: "pi pi-wallet",
        getIsActive: (match, location) => location.pathname.startsWith("/dashboard-financeiro"),
        items: [
          {
            label: localeText("centralFinanceira"),
            icon: "pi pi-wallet",
            to: "/dashboard-financeiro",
          },
          {
            label: localeText("wallet"),
            icon: "pi pi-wallet",
            to: "/dashboard-financeiro/carteira",
          },
          {
            label: "Extracredit",
            icon: "pi pi-dollar",
            to: "/dashboard-financeiro/extracredit",
          },
          {
            label: localeText("extrapayFlowTitle"),
            icon: "pi pi-bolt",
            to: "/dashboard-financeiro/extrapay",
          },
          {
            label: "Bonus ads",
            icon: "pi pi-money-bill",
            to: "/dashboard-extrabonusStatement",
          },
          {
            label: localeText("bonus"),
            icon: "pi pi-star",
            to: "/dashboard-bonusStatement",
          },
        ],
      },
      {
        label: localeText("myPurchases") || "Minhas compras",
        icon: "pi pi-shopping-cart",
        to: "/dashboard-purchases",
        getIsActive: (match, location) => location.pathname.startsWith("/dashboard-purchases"),
      },
      {
        label: localeText("store"),
        icon: "pi pi-shopping-bag",
        to: "/dashboard-store",
        getIsActive: (match, location) => location.pathname.startsWith("/dashboard-store"),
        items: [{ label: localeText("store"), icon: "pi pi-shopping-bag", to: "/dashboard-store" }],
      },
      {
        label: localeText("economicCircle"),
        icon: "pi pi-sitemap",
        to: "/dashboard-economic-circle",
        items: [
          {
            label: localeText("invite"),
            icon: "pi pi-link",
            to: "/dashboard-economic-circle/invite",
          },
          {
            label: localeText("membersAndTransactions"),
            icon: "pi pi-users",
            to: "/dashboard-economic-circle/members",
          },
        ],
      },
      {
        label: localeText("map"),
        icon: "pi pi-map-marker",
        to: "/dashboard-mapstores",
        getIsActive: (match, location) => location.pathname.startsWith("/dashboard-mapstores"),
        items: [{ label: localeText("map"), icon: "pi pi-map-marker", to: "/dashboard-mapstores" }],
      },
      /* {
        label: localeText("fringeBenefit"),
        icon: "pi pi-box",
        items: [
          {
            label: localeText("new"),
            icon: "pi pi-plus",
            to: "/dashboard-fringe-benefit",
          },
          {
            label: localeText("list"),
            icon: "pi pi-list",
            to: "/dashboard-list-fringe-benefit",
          },
        ],
      }, */
    ];
    return menuItems.filter(Boolean);
  };

  const getCustomerSimplifiedMenu = () => [
    {
      label: localeText("dashboard"),
      icon: "pi pi-table",
      items: [{ label: localeText("userDashboard"), icon: "pi pi-table", to: "/dashboard" }],
    },
    {
      label: localeText("upgradeAccount"),
      icon: "pi pi-chart-line",
      to: "/dashboard-upgrade",
      getIsActive: (match, location) => location.pathname.startsWith("/dashboard-upgrade"),
    },
    {
      label: localeText("financial"),
      icon: "pi pi-wallet",
      getIsActive: (match, location) => location.pathname.startsWith("/dashboard-financeiro"),
      items: [
        {
          label: localeText("centralFinanceira"),
          icon: "pi pi-wallet",
          to: "/dashboard-financeiro",
        },
        {
          label: localeText("wallet"),
          icon: "pi pi-wallet",
          to: "/dashboard-financeiro/carteira",
        },
        {
          label: localeText("extracredit"),
          icon: "pi pi-dollar",
          to: "/dashboard-financeiro/extracredit",
        },
        {
          label: localeText("extrapayFlowTitle"),
          icon: "pi pi-bolt",
          to: "/dashboard-financeiro/extrapay",
        },
      ],
    },
    {
      label: localeText("myPurchases") || "Minhas compras",
      icon: "pi pi-shopping-cart",
      to: "/dashboard-purchases",
      getIsActive: (match, location) => location.pathname.startsWith("/dashboard-purchases"),
    },
    {
      label: localeText("store"),
      icon: "pi pi-shopping-bag",
      to: "/dashboard-store",
      getIsActive: (match, location) => location.pathname.startsWith("/dashboard-store"),
      items: [{ label: localeText("store"), icon: "pi pi-shopping-bag", to: "/dashboard-store" }],
    },
    {
      label: localeText("map"),
      icon: "pi pi-map-marker",
      to: "/dashboard-mapstores",
      getIsActive: (match, location) => location.pathname.startsWith("/dashboard-mapstores"),
      items: [{ label: localeText("map"), icon: "pi pi-map-marker", to: "/dashboard-mapstores" }],
    },
    {
      label: localeText("integrations"),
      icon: "pi pi-cog",
      items: [
        {
          label: localeText("userDashboard"),
          icon: "pi pi-cog",
          to: "/dashboard-integrations",
        },
      ],
    },
  ];

  const legacyMenu = useMemo(() => {
    const walletPaths = [
      "/dashboard-walletStatement",
      "/dashboard-withdrawintent",
      "/dashboard-extrapay",
    ];
    const extracreditPaths = [
      "/dashboard-extracoinStatement",
      "/dashboard-extracoinintents",
      "/dashboard-extracointransfer",
    ];
    const isWalletActive = (_, loc) =>
      walletPaths.some((p) => loc.pathname === p || loc.pathname.startsWith(p + "/"));
    const isExtracreditActive = (_, loc) =>
      extracreditPaths.some((p) => loc.pathname === p || loc.pathname.startsWith(p + "/"));

    const carteiraItems = [
      canViewFeature("walletStatement") && {
        label: localeText("statement"),
        icon: "pi pi-list",
        to: "/dashboard-walletStatement",
      },
      canViewFeature("withdrawIntent") && {
        label: localeText("withdraw"),
        icon: "pi pi-bank",
        to: "/dashboard-withdrawintent",
      },
      canViewFeature("extrapay") && {
        label: "Extrapay",
        icon: "pi pi-credit-card",
        to: "/dashboard-extrapay",
      },
    ].filter(Boolean);

    const extracreditItems = [
      canViewFeature("extracoinStatement") && {
        label: localeText("statement"),
        icon: "pi pi-list",
        to: "/dashboard-extracoinStatement",
      },
      canViewFeature("extracoinIntents") && {
        label: localeText("transferRequests"),
        icon: "pi pi-inbox",
        to: "/dashboard-extracoinintents",
      },
      canViewFeature("extracoinTransfer") && {
        label: localeText("transfer"),
        icon: "pi pi-arrow-right-arrow-left",
        to: "/dashboard-extracointransfer",
      },
    ].filter(Boolean);

    const storePanelItems = canViewFeature("storePanel") && [
      {
        label: localeText("store"),
        icon: "pi pi-shopping-bag",
        to: "/dashboard-store",
      },
    ];

    const productServicesItems = canViewFeature("storePanel")
      ? storePanelItems
        ? [storePanelItems].flat()
        : []
      : [
          canViewFeature("products") && {
            label: localeText("new"),
            icon: "pi pi-plus",
            to: "/dashboard-newproduct",
          },
          canViewFeature("products") && {
            label: localeText("list"),
            icon: "pi pi-list",
            to: "/dashboard-products",
          },
          canViewFeature("attributes") && {
            label: localeText("attributes"),
            icon: "pi pi-tags",
            to: "/dashboard-attributes",
          },
          canViewFeature("favorites") && {
            label: localeText("favorites"),
            icon: "pi pi-heart-fill",
            to: "/dashboard-favorites",
          },
          canViewFeature("importProducts") && {
            label: localeText("importProducts"),
            icon: "pi pi-file-import",
            to: "/dashboard-importproducts",
          },
          canViewFeature("userStore") && {
            label: localeText("yourStore"),
            icon: "pi pi-shopping-bag",
            to: "/dashboard-userstore",
          },
        ].filter(Boolean);

    const fringeBenefitItems = [
      canViewFeature("fringeBenefit") && {
        label: localeText("new"),
        icon: "pi pi-plus",
        to: "/dashboard-fringe-benefit",
      },
      canViewFeature("fringeBenefit") && {
        label: localeText("list"),
        icon: "pi pi-list",
        to: "/dashboard-list-fringe-benefit",
      },
      canViewFeature("fringeBenefit") && {
        label: localeText("sales"),
        icon: "pi pi-shopping-cart",
        to: "/dashboard-sales-fringe-benefit",
      },
      canViewFeature("fringeBenefit") && {
        label: localeText("purchases"),
        icon: "pi pi-shopping-bag",
        to: "/dashboard-purchases-fringe-benefit",
      },
    ].filter(Boolean);

    const physicalStoreItems = [
      canViewFeature("qrCodePay") && {
        label: localeText("payWithQrCode"),
        icon: "pi pi-qrcode",
        to: "/dashboard-store-pay",
      },
      canViewFeature("storeTransactions") && {
        label: localeText("transactions"),
        icon: "pi pi-history",
        to: "/dashboard-store-transactions",
      },
    ].filter(Boolean);

    const sections = [
      {
        label: localeText("dashboard"),
        icon: "pi pi-chart-line",
        items: [{ label: localeText("userDashboard"), icon: "pi pi-chart-line", to: "/dashboard" }],
      },
      canAccessUpgradePage && {
        label: localeText("upgradeAccount"),
        icon: "pi pi-chart-line",
        items: [
          {
            label: localeText("upgradeAccount"),
            icon: "pi pi-chart-line",
            to: "/dashboard-upgrade",
          },
        ],
      },
      physicalStoreItems.length > 0 && {
        label: localeText("physicalStore"),
        icon: "pi pi-store",
        items: physicalStoreItems,
      },
      carteiraItems.length > 0 && {
        label: localeText("wallet"),
        icon: "pi pi-wallet",
        getIsActive: isWalletActive,
        items: carteiraItems,
      },
      extracreditItems.length > 0 && {
        label: "Extracredit",
        icon: "pi pi-dollar",
        getIsActive: isExtracreditActive,
        items: extracreditItems,
      },
      canViewFeature("extrabonusStatement") && {
        label: "Bonus ads",
        icon: "pi pi-money-bill",
        items: [
          {
            label: localeText("statement"),
            icon: "pi pi-list",
            to: "/dashboard-extrabonusStatement",
          },
        ],
      },
      canViewFeature("bonusStatement") && {
        label: localeText("dailyIncome"),
        icon: "pi pi-star",
        items: [
          {
            label: localeText("statement"),
            icon: "pi pi-list",
            to: "/dashboard-bonusStatement",
          },
        ],
      },
      canViewFeature("coupons") && {
        label: localeText("coupons"),
        icon: "pi pi-ticket",
        items: [{ label: localeText("list"), icon: "pi pi-list", to: "/dashboard-coupons" }],
      },
      fringeBenefitItems.length > 0 && {
        label: localeText("fringeBenefit"),
        icon: "pi pi-box",
        items: fringeBenefitItems,
      },
      productServicesItems.length > 0 && {
        label: canViewFeature("storePanel") ? localeText("store") : localeText("productServices"),
        icon: "pi pi-shopping-bag",
        items: productServicesItems,
      },
      canViewFeature("sales") && {
        label: localeText("sales"),
        icon: "pi pi-shopping-cart",
        items: [{ label: localeText("list"), icon: "pi pi-list", to: "/dashboard-sales" }],
      },
      canViewFeature("purchases") && {
        label: localeText("purchases"),
        icon: "pi pi-shopping-bag",
        items: [{ label: localeText("list"), icon: "pi pi-list", to: "/dashboard-purchases" }],
      },
      canViewFeature("networkDirects") && {
        label: localeText("economicCircle") || localeText("network"),
        icon: "pi pi-sitemap",
        items: [
          {
            label: localeText("economicCircle") || "Círculo econômico",
            icon: "pi pi-sitemap",
            to: "/dashboard-economic-circle",
          },
          {
            label: localeText("invite") || "Convite",
            icon: "pi pi-link",
            to: "/dashboard-economic-circle/invite",
          },
          {
            label: localeText("membersAndTransactions") || "Membros e transações",
            icon: "pi pi-users",
            to: "/dashboard-economic-circle/members",
          },
        ],
      },
      canViewFeature("web3Dashboard") && {
        label: "Crypto",
        icon: "pi pi-wallet",
        items: [{ label: "Crypto", icon: "pi pi-wallet", to: "/dashboard-web3dashboard" }],
      },
      canViewFeature("storesMap") && {
        label: localeText("StoresMap"),
        icon: "pi pi-map-marker",
        items: [{ label: localeText("map"), icon: "pi pi-map", to: "/dashboard-mapstores" }],
      },
    ];

    return sections.filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- canViewFeature from useDashboardPermissions(userTypeInfo)
  }, [userTypeInfo]);

  useEffect(() => {
    copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  const getUserInfoService = new GetUserInfoService();

  const {
    setAsFalse: setNotVisiblePopUp,
    setAsTrue: setVisiblePopUp,
    value: isVisiblePopUp,
  } = useToggle();

  const {
    setAsFalse: setNotVisiblePopUpExpired,
    setAsTrue: setVisiblePopUpExpired,
    value: isVisiblePopUpExpired,
  } = useToggle();

  const popUpLeftSubscriptionExpiration = () => {
    if (
      subscriptionInfo?.subscriptionDaysLeft <= 10 &&
      subscriptionInfo?.subscriptionDaysLeft >= 0 &&
      "/dashboard-renewsubscription" !== location.pathname
    ) {
      setVisiblePopUp();
    } else if (
      subscriptionInfo?.subscriptionDaysLeft < 0 &&
      "/dashboard-renewsubscription" !== location.pathname
    ) {
      setVisiblePopUpExpired();
    } else {
      setNotVisiblePopUp();
    }
  };

  useEffect(() => {
    if (!isLoadingSubscriptionInfo) popUpLeftSubscriptionExpiration(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingSubscriptionInfo, location]);

  useEffect(() => {
    let cancel = false;
    async function fetchData() {
      if (localStorage.getItem("__extraconomy_token")) {
        setLoadingAdmin(true);

        const resType = await getUserInfoService.getUserTypeInfo(
          localStorage.getItem("__extraconomy_username"),
        );

        if (cancel) return;

        if (resType.messageCode !== 200001) {
          setLoadingAdmin(false);
        } else {
          setUserTypeInfo(resType.result);

          if (resType.result === "Admin" || resType.result === "Accountant") {
            setUserAdminType(resType.result);
            setLoadingAdmin(false);
          } else {
            try {
              // User info
              getUserInfoService
                .getUserInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) {
                    setUserPlan(res.result.plan);
                    setUserInfo(res.result.user);
                  } else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // Wallet info
              await getUserInfoService
                .getWalletInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) {
                    setWalletInfo(res.result);
                    setCurrency(handleCurrency(res.result.currency));
                  } else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });

              // Extracredit info
              getUserInfoService
                .getExtracoinInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) setExtracoinInfo(res.result);
                  else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // Directs in economic circle
              getUserInfoService
                .getNetworkDirectsInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) {
                    setDirectsInfo(res.result);
                    const arr = [];

                    res.result.forEach((element) => {
                      arr.push(element);
                    });

                    setDirectsArray(arr);
                  } else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // All nodes in economic circle
              getUserInfoService
                .getNetworkAllInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) {
                    setAllNodesInfo(res.result);
                    const arr = [];

                    res.result.forEach((element) => {
                      arr.push(element);
                    });

                    setAllNodesArray(arr);
                  } else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // User Subscription info
              if (
                /manager/i.test(resType.result) ||
                /partner/i.test(resType.result) ||
                /seller/i.test(resType.result)
              )
                getUserInfoService
                  .getSubscriptionInfo(
                    localStorage.getItem("__extraconomy_token"),
                    localStorage.getItem("__extraconomy_username"),
                  )
                  .then((res) => {
                    if (res.messageCode === 200001) {
                      setSubscriptionInfo({
                        ...res.result,
                        subscriptionFormattedData: `${formatDate(new Date(res.result.dateBegin))} -
                    ${formatDate(new Date(res.result.dateEnd))}`,
                        subscriptionDaysLeft:
                          ((new Date(res.result.dateEnd) - Date.now()) / 86400000) | 0,
                      });
                    } else {
                      localStorage.removeItem("__extraconomy_token");
                      localStorage.removeItem("__extraconomy_username");
                      Navigate.replace("/login", {
                        from: `${location.pathname}${location.search}`,
                      });
                    }
                  })
                  .finally(() => setIsLoadingSubscriptionInfo(false));
              // User activation info
              getUserInfoService
                .getActivationInfo(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) setActivationInfo(res.result);
                  else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // Lifetime bonus of wallet
              getUserInfoService
                .getWalletLifetimeBonus(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) setLifetimeBonusInfo(res.result);
                  else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              // Extracredit percentage usage credit
              getUserInfoService
                .getExtracoinPercentage(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                )
                .then((res) => {
                  if (res.messageCode === 200001) setExtracoinPercentage(res.result);
                  else {
                    localStorage.removeItem("__extraconomy_token");
                    localStorage.removeItem("__extraconomy_username");
                    Navigate.replace("/login", {
                      from: `${location.pathname}${location?.search ? location?.search : ""}`,
                    });
                  }
                });
              setLoadingAdmin(false);
            } catch (e) {
              localStorage.removeItem("__extraconomy_token");
              localStorage.removeItem("__extraconomy_username");
              Navigate.replace("/login", {
                from: `${location.pathname}${location?.search ? location?.search : ""}`,
              });
            }
          }
        }
      } else {
        Navigate.replace("/login", {
          from: `${location.pathname}${location?.search ? location?.search : ""}`,
        });
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [retryGetExtracoinInfo, setRetryGetExtracoinInfo] = useState(false);

  const handleRetryGetExtracoinInfo = () => setRetryGetExtracoinInfo(true);

  useEffect(() => {
    if (retryGetExtracoinInfo) {
      setRetryGetExtracoinInfo(false);
      setLoadingAdmin(true);
      getUserInfoService
        .getExtracoinInfo(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
        )
        .then((res) => {
          if (res.messageCode === 200001) setExtracoinInfo(res.result);
          else {
            localStorage.removeItem("__extraconomy_token");
            localStorage.removeItem("__extraconomy_username");
            Navigate.replace("/login", {
              from: `${location.pathname}${location?.search ? location?.search : ""}`,
            });
          }
        })
        .finally(() => setLoadingAdmin(false));
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryGetExtracoinInfo]);

  const onDocumentClick = () => {
    if (isMobile() && staticMenuMobileActive) {
      setStaticMenuMobileActive(false);
    }
  };

  const onMenuitemClick = (event) => {
    if (isMobile() && !event.item?.items) {
      setStaticMenuMobileActive(false);
    }
  };

  const isMenuVisible = () => {
    if (isDesktop()) {
      return !staticMenuDesktopInactive;
    } else {
      return staticMenuMobileActive;
    }
  };

  const onMenuButtonClick = (event) => {
    if (isDesktop()) {
      setStaticMenuDesktopInactive(
        (prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive,
      );
    } else {
      setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
    }
    event?.preventDefault();
  };

  const isDesktop = () => {
    return window.innerWidth > 896;
  };

  const isMobile = () => {
    return window.innerWidth <= 896;
  };

  const isHomePage = location.pathname === "/dashboard";

  const isManager = userTypeInfo === "Manager";
  const isCustomer = userTypeInfo === "Customer";
  const isSeller = userTypeInfo === "Seller";
  const isPartner = userTypeInfo === "Partner";
  const isPromoter = userTypeInfo === "Promoter";
  const isStore = userTypeInfo === "Store";

  const shouldUseRefactoredSidebar =
    isManager || isCustomer || isSeller || isPartner || isPromoter || isStore;
  const containerClassName = classNames("dashboard-layout-wrapper", {
    "dashboard-layout-mobile-active": staticMenuMobileActive,
    "dashboard-home": isHomePage,
    "manager-dashboard-theme": isManager || isCustomer || isSeller || isPartner || isPromoter || isStore,
  });

  const routers = useMemo(
    () => [
      {
        path: "/dashboard-store-transactions",
        component: () => (
          <StoreTransactions user={userInfo} plan={userTypeInfo} currency={currency} />
        ),
        hasPermissionPlans: ["Store", "Manager"],
      },
      {
        path: "/dashboard-store-pay",
        component: () => <QrCodePay user={userInfo} plan={userTypeInfo} currency={currency} />,
      },
      {
        path: "/dashboard-networkdirects",
        component: () => <NetworkTable users={directsArray} directs={true} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-networkall",
        component: () => <NetworkTable users={allNodesArray} directs={false} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-economic-circle",
        component: () => (
          <EconomicCirclePage userInfo={userInfo} userTypeInfo={userTypeInfo} currency={currency} />
        ),
        exact: true,
      },
      {
        path: "/dashboard-economic-circle/invite",
        component: () => <EconomicCircleInvitePage userInfo={userInfo} />,
      },
      {
        path: "/dashboard-economic-circle/members",
        component: () => (
          <EconomicCircleMembersPage userInfo={userInfo} userTypeInfo={userTypeInfo} />
        ),
      },
      {
        path: "/dashboard-editprofile/:mainTab?/:subtab?",
        component: () => (
          <EditProfileInfo
            user={userInfo}
            plan={userTypeInfo}
            setUserInfo={setUserInfo}
            currency={currency}
          />
        ),
      },
      {
        path: "/dashboard-financeiro/extrapay/conheca",
        component: () => <ExtrapayKnowPage />,
      },
      {
        path: "/dashboard-financeiro/extrapay/saque",
        component: () => <ExtrapayWithdrawPage userInfo={userInfo} />,
      },
      {
        path: "/dashboard-financeiro/extrapay/saques/:id",
        component: () => <ExtrapayWithdrawDetailsPage userInfo={userInfo} />,
      },
      {
        path: "/dashboard-financeiro/extrapay/ciclo",
        component: () => <ExtrapayCyclePage />,
      },
      {
        path: "/dashboard-financeiro/extrapay",
        component: () => <ExtrapayPage />,
        exact: true,
      },
      {
        path: "/dashboard-financeiro/carteira",
        component: () => (
          <WalletPage userInfo={userInfo} userTypeInfo={userTypeInfo} currency={currency} />
        ),
      },
      {
        path: "/dashboard-financeiro/extracredit/transferir",
        component: () => (
          <ExtracreditTransferPage
            userInfo={userInfo}
            userTypeInfo={userTypeInfo}
            currency={currency}
          />
        ),
      },
      {
        path: "/dashboard-financeiro/extracredit",
        component: () => (
          <ExtracreditPage userInfo={userInfo} userTypeInfo={userTypeInfo} currency={currency} />
        ),
        exact: true,
      },
      {
        path: "/dashboard-financeiro",
        component: () => <FinancialHub userInfo={userInfo} userTypeInfo={userTypeInfo} />,
        exact: true,
      },
      {
        path: "/dashboard-integrations",
        component: () => <CustomerIntegrationsPage userInfo={userInfo} />,
        hasPermissionPlans: ["Customer"],
      },
      {
        path: "/dashboard-upgrade",
        component: () => (
          <UpgradePage
            userTypeInfo={userTypeInfo}
            currency={currency}
            userInfo={userInfo}
            canAccessUpgradePage={canAccessUpgradePage}
          />
        ),
        hasPermissionPlans: ["Customer", "Partner", "Seller", "Store"],
      },
      {
        path: "/dashboard-walletStatement",
        component: () => <StatementTable currency={currency} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-extracoinStatement",
        component: () => <StatementTable currency={currency} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-extrabonusStatement",
        component: () => (
          <StatementTable currency={currency} plan={userTypeInfo} onlyIntegerValues={true} />
        ),
      },
      {
        path: "/dashboard-bonusStatement",
        component: () => <StatementTable bonus={true} currency={currency} plan={userTypeInfo} />,
      },
      { path: "/dashboard-coupons", component: () => <Coupons plan={userTypeInfo} /> },
      // Remover rotas de store para Promoter
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/orders/details",
        component: () => <StoreOrderDetailsPage userInfo={userInfo} plan={userTypeInfo} />,
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/orders",
        component: () => <StoreOrdersPage />,
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
        exact: true,
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/settings",
        component: () => <StoreSettingsPage userInfo={userInfo} />,
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store"],
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/products/new",
        component: () => (
          <StoreProductFormPage
            plan={userTypeInfo}
            userInfo={userInfo}
            currencyCode={currency}
          />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
        exact: true,
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/products/:productId/edit",
        component: () => (
          <StoreProductFormPage
            plan={userTypeInfo}
            userInfo={userInfo}
            currencyCode={currency}
          />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
        exact: true,
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/products",
        component: () => (
          <StoreProductsPage
            plan={userTypeInfo}
            userInfo={userInfo}
            productsRefreshTrigger={productsRefreshTrigger}
          />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
        exact: true,
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store/schedules",
        component: () => (
          <StoreSchedulesPage userTypeInfo={userTypeInfo} userInfo={userInfo} currency={currency} />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
      },
      userTypeInfo === "Store" && {
        path: "/dashboard-store/physical-store",
        component: () => <PhysicalStorePage userInfo={userInfo} currency={currency} />,
        hasPermissionPlans: ["Store"],
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-store",
        component: () => (
          <StorePanelPage
            userTypeInfo={userTypeInfo}
            userInfo={userInfo}
            currency={currency}
            productsRefreshTrigger={productsRefreshTrigger}
          />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
        exact: true,
      },
      // Remover rotas de produtos, atributos para Promoter
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-products",
        component: () => (
          <ProductsList plan={userTypeInfo} currency={currency} userInfo={userInfo} />
        ),
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-attributes",
        component: () => <Attributes plan={userTypeInfo} />,
        hasPermissionPlans: ["Manager", "Seller", "Partner", "Store", "Customer"],
      },
      {
        path: "/dashboard-sales",
        component: () => <Orders sales={true} userInfo={userInfo} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-salesdetails/",
        component: () => <OrderDetails sales={true} userInfo={userInfo} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-purchases-evaluate/",
        component: () => <EvaluateOrder />,
      },
      {
        path: "/dashboard-purchases",
        component: () => <Orders sales={false} userInfo={userInfo} plan={userTypeInfo} />,
        exact: true,
      },
      {
        path: "/dashboard-purchasesdetails/",
        component: () => <OrderDetails sales={false} userInfo={userInfo} plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-extracointransfer",
        component: () => (
          <ExtracoinTransfer
            currency={currency}
            extracoinInfo={extracoinInfo}
            userTypeInfo={userTypeInfo}
          />
        ),
      },
      {
        path: "/dashboard-extracoinintents",
        component: () => <ExtracoinIntents currency={currency} userTypeInfo={userTypeInfo} />,
      },
      {
        path: "/dashboard-withdrawintent",
        component: () => <WithdrawIntent />,
      },
      { path: "/dashboard-extrapay", component: () => <ExtraPay extracoinInfo={extracoinInfo} /> },
      // Remover favoritos e importação de produtos para Promoter
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-favorites",
        component: () => <FavoritedProducts />,
      },
      userTypeInfo !== "Promoter" && {
        path: "/dashboard-importproducts",
        component: () => <ImportProducts plan={userTypeInfo} />,
      },
      {
        path: "/dashboard-renewsubscription",
        component: () =>
          userHasSubscription ? (
            <RenewSubscription setSubscriptionInfo={setSubscriptionInfo} />
          ) : (
            <Redirect to="/dashboard" />
          ),
      },
      { path: "/dashboard-web3dashboard", component: () => <Web3Dashboard plan={userTypeInfo} /> },
      {
        path: "/dashboard-mapstores",
        component: () => <StoresMap plan={userTypeInfo} userTypeInfo={userTypeInfo} />,
      },
      {
        path: "/dashboard-white-label",
        component: () => <WhiteLabelPage />,
        hasPermissionPlans: ["Manager"],
      },
      {
        path: "/dashboard-businesssquare",
        component: () => <PartnerB2BPage userInfo={userInfo} userTypeInfo={userTypeInfo} />,
        hasPermissionPlans: ["Manager"],
      },
      {
        path: "/dashboard-partner-services",
        component: () => <PartnerServicesPage />,
        hasPermissionPlans: ["Manager"],
      },
      {
        path: "/dashboard-partner-stores",
        component: () => <UnderConstruction businessSquareMenu={true} />,
        hasPermissionPlans: ["Manager"],
      },
      {
        path: "/dashboard-welfare",
        component: () => <UnderConstruction businessSquareMenu={true} />,
        hasPermissionPlans: ["Manager"],
      },
      {
        path: "/dashboard-my-cards",
        component: () => <MyCards userInfo={userInfo} />,
        hasPermissionPlans: ["Manager"],
      },
      /* {
        path: "/dashboard-business-diagnosis",
        component: () => <BusinessDiagnosisPage />,
        hasPermissionPlans: ["Manager"],
      }, */
      {
        path: "/dashboard-fringe-benefit",
        component: () => <FringeBenefit currency={currency} user={userInfo} />,
      },
      {
        path: "/dashboard-list-fringe-benefit",
        component: () => <FringeBenefitsList />,
      },
      {
        path: "/dashboard-edit-fringe-benefit",
        component: () => <FringeBenefitEdit />,
      },
      {
        path: "/dashboard-purchases-fringe-benefit",
        component: () => <FringeBenefitsPurchases />,
      },
      {
        path: "/dashboard-sales-fringe-benefit",
        component: () => <FringeBenefitsSales />,
      },
      {
        path: "/dashboard",
        component: () => {
          if (
            userTypeInfo === "Manager" ||
            userTypeInfo === "Seller" ||
            userTypeInfo === "Partner" ||
            userTypeInfo === "Store" ||
            userTypeInfo === "Promoter"
          ) {
            return <ManagerDashboardHome userTypeInfo={userTypeInfo} userInfo={userInfo} />;
          }
          if (userTypeInfo === "Customer") {
            return (
              <CustomerDashboardHome
                userInfo={userInfo}
                userTypeInfo={userTypeInfo}
                currency={currency}
                extracoinInfo={extracoinInfo}
              />
            );
          }
          return (
            <UserDashboardHome
              walletInfo={walletInfo}
              extracoinInfo={extracoinInfo}
              userInfo={userInfo}
              userTypeInfo={userTypeInfo}
              currency={currency}
              directsInfo={directsInfo}
              allNodesInfo={allNodesInfo}
              subscriptionInfo={subscriptionInfo}
              activationInfo={activationInfo}
              lifetimeBonusInfo={lifetimeBonusInfo}
              extracoinPercentage={extracoinPercentage}
            />
          );
        },
        exact: true,
      },
    ],
    [
      activationInfo,
      allNodesArray,
      allNodesInfo,
      currency,
      directsArray,
      directsInfo,
      extracoinInfo,
      extracoinPercentage,
      lifetimeBonusInfo,
      canAccessUpgradePage,
      productsRefreshTrigger,
      subscriptionInfo,
      userInfo,
      userTypeInfo,
      walletInfo,
      userHasSubscription,
    ],
  );

  return (
    <div id="home">
      {loadingAdmin ? (
        <div className="flex justify-content-center align-items-center text-center min-h-screen surface-300">
          <i className="pi pi-spin pi-spinner text-8xl text-600"></i>
        </div>
      ) : (
        <>
          {userAdminType ? (
            <AdminEntry userType={userAdminType} />
          ) : (
            <div className={containerClassName} onClick={onDocumentClick}>
              <FiscalDataGate userInfo={userInfo} />
              <ConfirmDocument />

              {subscriptionInfo && userHasSubscription && (
                <Dialog
                  header={`${localeText("popupHeader1")} ${
                    subscriptionInfo?.subscriptionDaysLeft
                  } ${localeText("popupHeader2")}`}
                  visible={isVisiblePopUp}
                  className="w-30rem m-2"
                  onHide={() => setNotVisiblePopUp()}
                  draggable={false}
                >
                  <p>
                    {localeText("subscriptionExpirationDate")}
                    {": "}
                    {formatDate(new Date(subscriptionInfo?.dateEnd))}
                  </p>
                  <p>{localeText("wantToRenewSubscription")}</p>
                  <div className="flex gap-2 justify-content-end">
                    <Button onClick={setNotVisiblePopUp} severity="danger">
                      {localeText("no")}
                    </Button>
                    <Button
                      onClick={() => {
                        Navigate.push("/dashboard-renewsubscription");
                        setNotVisiblePopUp();
                      }}
                    >
                      <div className="flex justify-content-center align-items-center gap-2">
                        <p>{localeText("yes")}</p>
                      </div>
                    </Button>
                  </div>
                </Dialog>
              )}

              {subscriptionInfo && userHasSubscription && (
                <Dialog
                  header={localeText("yourSubcriptionExpired")}
                  visible={isVisiblePopUpExpired}
                  className="w-30rem m-2"
                  onHide={() => setNotVisiblePopUpExpired()}
                  draggable={false}
                  closable={false}
                >
                  <p>{localeText("wantToRenewyourSubscription")}</p>
                  <div className="flex gap-2 justify-content-between">
                    <Button
                      onClick={() => {
                        localStorage.removeItem("__extraconomy_token");
                        localStorage.removeItem("__extraconomy_username");
                        Navigate.replace("/shop");
                      }}
                      severity="warning"
                    >
                      {localeText("logoutAccount")}
                    </Button>
                    <div className="flex gap-2">
                      <Button onClick={() => Navigate.push("")} severity="danger">
                        {localeText("no")}
                      </Button>
                      <Button
                        onClick={() => {
                          Navigate.push("/dashboard-renewsubscription");
                          setNotVisiblePopUpExpired();
                        }}
                      >
                        <div className="flex justify-content-center align-items-center gap-2">
                          <p>{localeText("yes")}</p>
                        </div>
                      </Button>
                    </div>
                  </div>
                </Dialog>
              )}

              <Tooltip
                ref={copyTooltipRef}
                target=".block-action-copy"
                position="bottom"
                content="Copied to clipboard"
                event="focus"
              />

              {shouldUseRefactoredSidebar ? (
                <ThemeProvider userInfo={userInfo}>
                  <SEO />
                  <ManagerLayout
                    getSimplifiedMenu={
                      isManager || isSeller || isPartner || isPromoter || isStore
                        ? getSimplifiedMenu
                        : isCustomer
                          ? () => getCustomerSimplifiedMenu()
                          : () => legacyMenu
                    }
                    userInfo={userInfo}
                    userTypeInfo={userTypeInfo}
                    isMenuVisible={isMenuVisible}
                    onMenuItemClick={onMenuitemClick}
                    onMenuButtonClick={onMenuButtonClick}
                    routers={routers}
                  />
                </ThemeProvider>
              ) : (
                <>
                  <LegacyDashboardSidebar
                    menuItems={legacyMenu}
                    userInfo={userInfo}
                    userTypeInfo={userTypeInfo}
                    isMenuVisible={isMenuVisible}
                    onMenuItemClick={onMenuitemClick}
                    onMenuButtonClick={onMenuButtonClick}
                  />
                  <div className="layout-main dashboard-layout-main" id="home">
                    <div className="layout-content">
                      <DashboardRouter routers={routers} userTypeInfo={userTypeInfo} />
                    </div>
                  </div>
                </>
              )}

              {staticMenuMobileActive && (
                <div
                  className="dashboard-layout-mask"
                  onClick={() => setStaticMenuMobileActive(false)}
                  onTouchStart={(e) => {
                    maskTouchStartRef.current = e.touches[0]?.clientX ?? null;
                  }}
                  onTouchMove={(e) => {
                    const startX = maskTouchStartRef.current;
                    if (startX == null) return;
                    const currentX = e.touches[0]?.clientX ?? startX;
                    const delta = startX - currentX;
                    if (delta > 60) {
                      setStaticMenuMobileActive(false);
                      maskTouchStartRef.current = null;
                    }
                  }}
                  onTouchEnd={() => {
                    maskTouchStartRef.current = null;
                  }}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserDashboard;
